// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { makeDate } from "src/lib/utils.js";

// Stateful components

export class Timeline extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            timeline_ranges: [],
            max_left: false,
            max_right: false,
            total_width: null,
            x_positon: null
        };

        this.interval = "December";
        this.period = 2;

        this.timelineNext = this.timelineNext.bind(this);
        this.timelinePrev = this.timelinePrev.bind(this);
    }

    
    componentDidMount() {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        
        var timeline_settings = configuration['timeline'];
        if (timeline_settings) {

            if (timeline_settings['axis_label']) {
                this_component['interval'] = timeline_settings['axis_label'];
            }
            
            if (timeline_settings['years_in_range']) {
                this_component['period'] = timeline_settings['years_in_range'];
            }
        }

        var timeline_events = this_component.getEventsFromStorage();
        var timeline_ranges = this_component.generateRanges(timeline_events);
        var current_range_index = this_component.getCurrentRangeIndex(timeline_ranges);
        
        var total_width = 1200 * timeline_ranges.length + 60;
        var x_positon_initial = 0 - current_range_index * 1200;
        var max_left = false;

        if (x_positon_initial === 0) {
            max_left = true;
        }

        this_component.setState({
            timeline_ranges: timeline_ranges,
            max_left: max_left,
            max_right: false,
            total_width: total_width,
            x_positon: x_positon_initial
        });

    }

    //
    // Events
    //

    // Move to next x position within timeline
    timelineNext(e) {
        e.preventDefault();

        var this_component = this;
        var updated_x_position;
        var max_right = false;
        
        var NEXT_POSITION = this_component['state']['x_positon'] - 200;
        var BOUNDARY_RIGHT = 0 - (this_component['state']['total_width'] - 400);
        
        if (NEXT_POSITION < BOUNDARY_RIGHT) {
            updated_x_position = BOUNDARY_RIGHT;
            max_right = true;
        } else {
            updated_x_position = NEXT_POSITION;
        }

        this_component.setState({
            x_positon: updated_x_position,
            max_left: false,
            max_right: max_right
        });
    }

    // Move to previous x position within timeline
    timelinePrev(e) {
        e.preventDefault();

        var this_component = this;
        var updated_x_position;
        var max_left = false;

        var PREV_POSITION = this_component['state']['x_positon'] + 200;
        var BOUNDARY_LEFT = 0;
        
        if (PREV_POSITION > BOUNDARY_LEFT) {
            updated_x_position = BOUNDARY_LEFT;
            max_left = true;
        } else {
            updated_x_position = PREV_POSITION;
        }

        this_component.setState({
            x_positon: updated_x_position,
            max_left: max_left,
            max_right: false
        });
    }

    handleItemClick(e) {
        e.preventDefault();
    }


    //
    // Functions
    //

    getEventsFromStorage() {
        var all_data = squiz.fn.getStorage('getmyresearch', 'session', 'json');
        
        if (all_data) {
            var research_data = all_data['data'];

            if (research_data) {

                // Some default date types
                var normal_dates = [
                    {
                        name: "commencedDate",
                        friendly_name: "Commenced",
                        show_in_timeline: true
                    },
                    {
                        name: "confirmationDate",
                        friendly_name: "Confirmation",
                        show_in_timeline: false
                    },
                    {
                        name: "earlyCandidatureMilestone",
                        friendly_name: "Early candidature milestone",
                        show_in_timeline: false
                    },
                    {
                        name: "minSubmissionDate",
                        friendly_name: "Minimum submission date",
                        show_in_timeline: true
                    },
                    {
                        name: "maxSubmissionDate",
                        friendly_name: "Maximum submission date",
                        show_in_timeline: true
                    }
                ];
    
                var milestone_dates = [
                    {
                        name: "dateRequired",
                        friendly_name: "due"
                    },
                    {
                        name: "dateCompleted",
                        friendly_name: "completed"
                    }
                ];

                // Array to return
                var timeline_events = [];
                var date_format = 'DD/MM/YYYY';
    
                // Add normal dates to timeline events
                normal_dates.forEach(function(event, key) {
                    var date = research_data[event['name']];
                    var date_formatted = makeDate(date, date_format);
                    research_data[event['name'] + 'Rendered'] = date_formatted;
                    if (event['show_in_timeline']) {
                        timeline_events.push({
                            "name": event['friendly_name'],
                            "date_start": date
                        });
                    }
                });

                // Add milestones to timeline events
                research_data['normal_dates'] = [];
                var milestones = research_data['milestones'];
                if (milestones) {
                    milestones.forEach(function(milestone, key) {
                        var description = milestone['description'];
                        
                        milestone_dates.forEach(function(type, key2) {
                            var date = milestone[type['name']];
                            var date_formatted = makeDate(date, date_format);
                            milestone[type['name'] + 'Rendered'] = date_formatted;
                            timeline_events.push({
                                "name": description + " " + type['friendly_name'],
                                "date_start": date
                            });
                        });

                    });
                }
                
                return timeline_events;
            }
        }

        return null;
    }

    // Get first axis date
    getFirstAxisDate(first_event) {
        var axis_interval = this['interval'];

        if (typeof(first_event) !== 'undefined') {
            
            var first_event_start = new Date(first_event['date_start']);
            var first_axis_date = new Date("1 " + axis_interval + " " + first_event_start.getFullYear());

            if (first_axis_date.getTime() >= first_event_start.getTime()) {
                first_axis_date = new Date("1 " + axis_interval + " " + (first_event_start.getFullYear() - 1));
            }
            return first_axis_date;
        }

        return null;
    }

    // Get last 'horizon' date in range
    getHorizon(first_axis_date, offset) {
        
        var axis_interval = this['interval'];
        var total_years = this['period'];
        var first_year = first_axis_date.getFullYear();

        offset = offset + 1;
        var years_added;

        if (offset) {
            years_added = total_years * offset;
        } else {
            years_added = total_years;
        }

        var horizon = new Date("1 " + axis_interval + " " + (first_year + years_added));

        return horizon;
    }

    // Rendex axis label
    renderAxisLabel(date, start, end) {
        var this_component = this;

        return {
            "date_start": date,
            "position": this_component.getPosition(date, start, end, 0),
            "name": moment.months(date.getMonth()) + " " + date.getFullYear(),
            "type": "milestone"
        };
    }

    // Generate axis labels within range
    generateAxisLabels(start, end) {
        var this_component = this;
        var axis_labels = [];
        var axis_interval = this['interval'];
        
        var date = start;
        var num_years = end.getFullYear() - start.getFullYear();

        // Push first label
        var first_label = this_component.renderAxisLabel(date, start, end);
        axis_labels.push(first_label);

        // Increment date by one year and push new label(s)
        for (var i = 0; i < num_years; i++) {
            var year = date.getFullYear();
            date = new Date("1 " + axis_interval + " " + (year + 1));
            var axis_label = this_component.renderAxisLabel(date, start, end);
            axis_labels.push(axis_label);
        }

        // Return all labels
        return axis_labels;
    }


    // Generate ranges array
    generateRanges(event_list) {
        var this_component = this;
        
        // Add 'event' type to each event
        event_list.forEach(function(event, key) {
            event['type'] = 'event';
        });

        // Sort events by date
        var event_list_sorted = event_list.sort(function(a, b) {
            return new Date(a['date_start']) - new Date(b['date_start']);
        });

        // Filter out events with '0' time
        var event_list_filtered = event_list_sorted.filter(function(event, event_key) {
            return new Date(event['date_start']).getTime() > 0;
        });

        // Get first axis date
        var first_event = event_list_filtered[0];
        var first_axis_date = this_component.getFirstAxisDate(first_event);

        // Initialise some vars
        var ranges = [];
        var current_range = -1;
        var old_horizon = first_axis_date;
        var new_horizon = new Date(0);
        
        // Loop through events and push to corresponding 'range' object
        event_list_filtered.forEach(function(event, key) {
            
            // Timezone utility not required as date_start includes GMT+10
            var events_combined;
            var event_start = new Date(event['date_start']).getTime();

            if (event_start > 0) {

                // Push event to range object IF it is before the end horizon
                if (event_start < new_horizon.getTime()) {
                    ranges[current_range]['events'].push(event);

                // Create new range object
                } else {
                    current_range = current_range + 1;
                    if (current_range < 1) {
                        old_horizon = first_axis_date;
                    } else {
                        old_horizon = new_horizon;
                    }

                    new_horizon = this_component.getHorizon(first_axis_date, current_range);

                    var axis_labels = this_component.generateAxisLabels(old_horizon, new_horizon);

                    events_combined = [].concat(axis_labels).concat([event]);

                    var you_are_here = this_component.detectYouAreHere(old_horizon, new_horizon);

                    ranges[current_range] = {
                        "range_start": old_horizon,
                        "range_end": new_horizon,
                        "events": events_combined,
                        "you_are_here": you_are_here
                    };
                }
            }
        });

        // Configure each 'range' object in 'ranges'
        ranges.forEach(function(range, range_key) {
            var date_format = 'DD/MM/YYYY';

            // Sort events in range by date
            range['events'] = range['events'].sort(function(a, b) {
                return makeDate(a['date_start']) - new Date(b['date_start']);
            });

            // Get position and formatted dates for each event in range
            range['events'].forEach(function(event, event_key) {

                event['position'] = this_component.getPosition(
                    new Date(event['date_start']),
                    range['range_start'],
                    range['range_end'],
                    event_key
                );

                event['date_start_rendered'] = makeDate(event['date_start'], date_format);
                if (typeof(event['date_end']) !== 'undefined') {
                    event['date_end_rendered'] = makeDate(event['date_end'], date_format);
                }
            });

            // Check proximity off events (and add offset if applicable)
            range['events'].forEach(function(event, event_key) {
                var prev, next, prox;

                if (event_key - 2 > -1) {
                    prev = range['events'][event_key - 2];
                } else {
                    prev = null;
                }

                if (event_key + 2 <= range['events'].length) {
                    next = range['events'][event_key + 2];
                } else {
                    next = null;
                }

                if (typeof(event['position']['offset']) == 'undefined') {
                    prox = this_component.getProximityDecision(event, prev, next);

                    switch(prox) {
                        case 0: 
                            event['position']['offset'] = "16px";
                            break;
                        case 1:
                            event['position']['offset'] = "43px";
                            break;
                        case 2:
                            event['position']['offset'] = "43px";
                            next['position']['offset'] = "68px";
                            break;
                    }
                }
            });

        });

        // Return complete 'ranges' array
        return ranges;
    }

    
    // Get proximity of two events
    //     0: No overlap
    //     1: Minor overlap
    //     2: Major overlap
   
    getProximityDecision(event, prev, next) {

        var prev_current = false;
        var next_prev = false;
        var one_percent = 13;
        var width = 155;

        if (prev) {
            if ((event['position']['percent'] - prev['position']['percent']) * one_percent < width) {
                prev_current = true;
            }
        }

        if (next && prev) {
            if ((next['position']['percent'] - prev['position']['percent']) * one_percent < width) {
                next_prev = true;
            }
        }

        if (next_prev) {
            return 2;
        } else if (prev_current) {
            return 1;
        } else {
            return 0;
        }
    }

    // Get position of event in 'range'
    getPosition(event, start, end, key) {
        var event_time = event.getTime();
        var start_time = start.getTime();
        var end_time = end.getTime();

        var total = end_time - start_time;
        var difference = event_time - start_time;
        var percent = difference / (total / 100);

        return {
            percent: percent,
            below: key % 2
        };
    }

    // Return timeline position of current date if within range
    detectYouAreHere(start, end) {
        var this_component = this;
        var now = new Date();

        if (now.getTime() < end.getTime() && now.getTime() > start.getTime()) {
            return this_component.getPosition(now, start, end, 0);
        } else {
            return false;
        }
    }

    // Get range index matching the current time
    getCurrentRangeIndex(timeline_ranges) {
        var found = 0;
        var now = new Date().getTime();

        timeline_ranges.forEach(function(range, key) {
            if (now > range['range_start'].getTime() && now < range['range_end'].getTime()) {
                found = key;
            }
        });

        return found;
    }



    //
    // Render
    //

    renderRanges() {
        var this_component = this;
        
        var timeline_ranges = this_component['state']['timeline_ranges'];
        var current_range_index = this_component.getCurrentRangeIndex(timeline_ranges);

        return timeline_ranges.map(function(range, range_key) {
            
            var event_markers = this_component.renderEventMarkers(range['events']);
            
            var you_are_here = range['you_are_here'] ? (
                <div className="timeline__you-are-here" style={{"left": range['you_are_here']['percent'] + "%"}}>
                    <span className="timeline__you-are-here__text">You are here!</span>
                </div>
            ) : null;
            
            
            return (
                <div key={range_key} className={"timeline__range" + (range_key !== current_range_index ? " timeline__range--hidden" : "")}>
                    {event_markers}
                    {you_are_here}
                </div>
            );
        });
        
    }

    renderEventMarkers(events) {
        var this_component = this;

        return events.map(function(event, event_key) {
                
            var is_below = event['position']['below'] ? true : false;
            var offset_val = event['position']['offset'];
            var event_offset = {};
            
            if (typeof(event['position']['offset']) !== 'undefined') {
                if (is_below) {
                    event_offset = {
                        'marginTop': offset_val
                    };
                } else {
                    event_offset = {
                        'marginBottom': offset_val
                    };
                }
            }

            var event_type = event['type'];
            

            return (
                <div
                    key={event_key}
                    className={"timeline__marker" + (is_below ? " timeline__marker--below" : " timeline__marker--above") + " timeline__marker--" + event_type}
                    style={{
                        "left": event['position']['percent'] + "%"
                    }}
                >
                    <span className="timeline__marker--icon"></span>
                    
                    {event['type'] === 'event' ? (
                        <span className="timeline__event" style={event_offset}>
                            <span className="timeline__event__angle-wrapper">
                                <span className="timeline__event__angle"></span>
                            </span>
                            <span 
                                className={"timeline__event__inner" + (event['name'].length > 35 ? " event--small" : "")}
                                data-eventlength={event['name'].length}
                            >
                                <span>{event['name']} - {event['date_start_rendered']}</span>
                                
                                {event['date_end_rendered'] ? (
                                    <span>event['date_end_rendered']</span>
                                ) : null}
                            </span>
                        </span>
                    ) : null}

                    {event['type'] === 'milestone' ? (
                        <span className="timeline__marker--milestone__text" style={event_offset}>
                            {event['name']}
                        </span>
                    ) : null}

                </div>
            );
        });
    }


    render() {
        var this_component = this;

        var max_left = this_component['state']['max_left'];
        var max_right = this_component['state']['max_right'];
        var total_width = this_component['state']['total_width'];
        var x_positon = this_component['state']['x_positon'];

        return (
            <div className="timeline__wrapper">
                <ContextualMessage id="research_timeline" />
                <div className="timeline timeline--mid timeline--tablet">
                    <div className="timeline__inner">
                        
                        {!max_left ? (
                            <a className="timeline__prev" onClick={this_component.timelinePrev} href="#">
                                Prev
                            </a>
                        ) : null}
                       
                        <div className="timeline__range-track-wrapper">

                            <span className={"timeline__range-track-cover" + (max_left ? " timeline__range-track-cover--hidden" : "") + " timeline__range-track-cover--left"}>
                            </span>

                            <div
                                className="timeline__range-track clearfix"
                                style={{
                                    "width": total_width + "px",
                                    "left": x_positon + "px"}}
                            >
                                {this_component.renderRanges()}
                            </div>

                            <span className={"timeline__range-track-cover" + (max_right ? " timeline__range-track-cover--hidden" : "") + " timeline__range-track-cover--right"}>
                            </span>

                        </div>

                        {!max_right ? (
                            <a className="timeline__next" onClick={this_component.timelineNext} href="#">
                                Next
                            </a>
                        ) : null}

                    </div>
                </div>
            </div>
        );
    }

};

Timeline.contextType = PortalContext;
